import { PREGUNTAS_TAKIS, leerTakis, escribirTakis } from '../domain/takisCierre';
import type { RespuestasTakis } from '../domain/takisCierre';

/** Mismas preguntas y respuestas para el celular y las correcciones de oficina. */
export default function TakisEjecucion({ valor, onChange }: {
  valor: string; onChange: (texto: string) => void;
}) {
  const r = leerTakis(valor);
  const set = (campo: keyof RespuestasTakis, v: string) => onChange(escribirTakis({
    ...r, [campo]: v, ...(campo === 'conteo_personas' && v === 'no_conte' ? { personas: '' } : {}),
  }));
  const clase = 'min-h-[44px] w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm';
  return (
    <section className="mb-4 rounded-xl border border-gray-200 bg-white p-4">
      <h2 className="mb-2 text-base font-bold text-gray-900">Degustación y promoción Takis</h2>
      <p className="mb-4 text-sm text-gray-600">
        El foco es Intense Nacho y Ranch: sabores intensos, sin picante.
        Registra lo que ocurrió en tu tienda.
      </p>
      {PREGUNTAS_TAKIS.map((p) => (
        <div key={p.campo} className="mb-4">
          <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor={`takis-${p.campo}`}>{p.label}</label>
          {p.campo === 'fanta' && <p className="mb-1 text-xs text-gray-500">
            La capacitación anunció Fanta de 500 ml + Takis de 90 g (Ranch 85 g) a S/ 3.90 por el Takis.
            Confirma si la promoción aplicaba; no todas las tiendas necesariamente la tienen.
          </p>}
          <select id={`takis-${p.campo}`} value={r[p.campo]} className={clase}
            onChange={(e) => set(p.campo, e.target.value)}>
            <option value="">Elige…</option>
            {p.opciones.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
          </select>
        </div>
      ))}
      <div className="mb-4">
        <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="takis-personas">¿A cuántas personas diste degustación hoy?</label>
        <p className="mb-1 text-xs text-gray-500">Cuenta a cada persona una vez, aunque pruebe ambos sabores. No cuentes palitos ni bolsas. Si no llevaste el conteo, puedes declarar una estimación e indicarlo arriba.</p>
        <input id="takis-personas" type="number" min={0} step={1} inputMode="numeric"
          disabled={!['contado', 'estimado'].includes(r.conteo_personas)}
          value={r.personas} onChange={(e) => set('personas', e.target.value)} className={clase} />
        {r.conteo_personas === 'no_conte' && <p className="mt-1 text-xs text-gray-500">Quedará registrado que no se midió; no se interpretará como cero personas.</p>}
      </div>
      <p className="mb-2 text-xs text-gray-500">Para degustación, cuenta bolsas abiertas, no palitos ni ventas. Si no lo contaste, deja el campo vacío.</p>
      {([
        ['bolsas_nacho', '¿Cuántas bolsas de Intense Nacho usaste para degustar?'],
        ['bolsas_ranch', '¿Cuántas bolsas de Ranch usaste para degustar?'],
      ] as const).map(([campo, label]) => (
        <div key={campo} className="mb-4">
          <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor={`takis-${campo}`}>{label} <span className="font-normal text-gray-500">· opcional</span></label>
          <input id={`takis-${campo}`} type="number" min={0} step={1} inputMode="numeric"
            value={r[campo]} onChange={(e) => set(campo, e.target.value)} className={clase} />
        </div>
      ))}
      <div className="mb-4">
        <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="takis-precio_ranch">Precio de Takis Ranch 85 g hoy (S/) <span className="font-normal text-gray-500">· opcional</span></label>
        <input id="takis-precio_ranch" type="text" inputMode="decimal" value={r.precio_ranch}
          onChange={(e) => set('precio_ranch', e.target.value)} className={clase} />
      </div>
      <div className="mb-4">
        <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="takis-detalle">¿Algo que explicar de la degustación o de la promoción?</label>
        <p className="mb-1 text-xs text-gray-500">Cuéntanos si faltaron muestras, tuviste que reponerlas o la promoción no pasó en caja. Si elegiste «Otro motivo», explica cuál.</p>
        <textarea id="takis-detalle" rows={3} value={r.detalle} onChange={(e) => set('detalle', e.target.value)} className={clase} />
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700" htmlFor="takis-observaciones">¿Algo más que contar de la tienda?</label>
        <textarea id="takis-observaciones" rows={3} value={r.observaciones} onChange={(e) => set('observaciones', e.target.value)} className={clase} />
      </div>
    </section>
  );
}
